module.exports = __webpack_public_path__ + "media/ingredients-cube-small.1318556c.mp4";